// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2084 ? "9b0008ae" : chunkId) + "." + {"2084":"e261410a063e1085","5203":"dbf42ffdd130568f","5714":"24a0414163cbcb69","6218":"ae958cc637ae36e0"}[chunkId] + ".js";
};